import React, {ReactPortal} from 'react';
import ReactDOM from 'react-dom';

import {Modal, ModalClose, ModalFooter, ModalHeader, Overlay, Wrapper} from "#app/components/ModalForm/styles";

import CloseIcon from "./images/close.svg";

const ModalForm = ({
                       modalVisible,
                       closeForm,
                       children,
                       header = '',
                       width = 'auto',
                       height = '90%',
                       fixedHeight = null
                   }): null | ReactPortal => {
    if (!modalVisible) return null;

    let modalElement = document.getElementById('modal');
    if (!modalElement) return null;
    const overlayStyleProps = (fixedHeight) ? {minHeight: fixedHeight, height: fixedHeight} : {};

    return ReactDOM.createPortal(
        <Overlay>
            <Wrapper style={overlayStyleProps}>
                <Modal width={width}>
                    <ModalHeader>
                        {header && (
                            <div>{header}</div>
                        )}
                        <ModalClose onClick={closeForm}>
                            <img src={CloseIcon as string} alt="Close"/>
                        </ModalClose>
                    </ModalHeader>
                    <ModalFooter>
                        {children}
                    </ModalFooter>
                </Modal>
            </Wrapper>
        </Overlay>,
        modalElement
    );
};

export default ModalForm;